module.exports = __webpack_public_path__ + "static/media/damage_closeup.b89942a3.svg";